import React from 'react';
import './Graphs.scss';
import { ResponsivePie } from '@nivo/pie';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { GraphData } from 'components/Analytics/types';
import { ReactComponent as IosBlue } from 'assets/icons/ios_blue.svg';
import { ReactComponent as AndroidGreen } from 'assets/icons/android_green.svg';
import { ReactComponent as WebBlue } from 'assets/icons/web_blue.svg';

type TGraphProps = {
  data: GraphData[];
  innerRadius?: number;
};

// Mirrors the pie + legend layout (circle on the left, legend rows on the right)
// so the card keeps the same footprint while data is loading.
export function PieGraphDeviceSkeleton({ legendCount = 3 }: { legendCount?: number }): JSX.Element {
  return (
    <div className="pie-chart-device pie-chart-device--loading">
      <Skeleton circle width={72} height={72} />
      <div className="pie-chart-device__legend-skeleton">
        {Array.from({ length: legendCount }).map((_, index) => (
          <Skeleton key={index} width={44} height={12} />
        ))}
      </div>
    </div>
  );
}

const Icons = (id: string) => {
  switch (id) {
    case 'android':
      return <AndroidGreen />;
    case 'ios':
      return <IosBlue />;
    default:
      return <WebBlue />;
  }
};

export default function PieGraphDevice(props: TGraphProps) {
  const renderResponsivePie = () => (
    <ResponsivePie
      data={props.data}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
      innerRadius={props.innerRadius}
      padAngle={0.7}
      colors={{ datum: 'data.color' }}
      cornerRadius={0}
      enableArcLabels={false}
      enableArcLinkLabels={false}
      theme={{
        legends: {
          text: {
            fontSize: 12,
            fontWeight: 600,
          },
        },
      }}
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          translateX: -7,
          translateY: 0,
          itemsSpacing: 8,
          itemWidth: 60,
          itemHeight: 16,
          itemDirection: 'left-to-right',
          itemTextColor: '#505a72',
          symbolSize: 15,
          // eslint-disable-next-line react/prop-types
          symbolShape: (props) => Icons(`${props.id}`),
        },
      ]}
    />
  );

  //(['android', 'ios', 'other'].includes(`${props.id}`) ? <AndroidPink /> : <IosBlue />),
  return <div className="pie-chart-device">{renderResponsivePie()}</div>;
}
